import styled, { css } from 'styled-components'
import { theme, Button } from '@notino/react-styleguide'
import { NotinoBodyLarge, NotinoBodyMedium, NotinoBodyRegular, NotinoBodySmall, NotinoLabelLarge, resetButtonStyles } from '../../../../styles/helpers'

export const Section = styled.section<{ $paddingTop?: number }>`
	padding-bottom: 24px;
	padding-top: ${(p) => p.$paddingTop ?? 24}px;

	&:not(:last-child) {
		border-bottom: 1px solid ${theme.color.border.divider};
	}
`

export const SectionHeading = styled.h2<{ $marginBottom?: number }>`
	/* resetting global notino margin on heading */
	margin: 0 0 ${(p) => p.$marginBottom ?? 16}px;

	${NotinoLabelLarge};
	display: flex;
	align-items: center;
	gap: 8px;

	svg {
		flex-shrink: 0;
	}
`

export const SectionRow = styled.div<{ $marginBottom?: number }>`
	${NotinoLabelLarge};
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: ${(p) => p.$marginBottom ?? 16}px;

	svg {
		flex-shrink: 0;
	}
`

export const AboutUsText = styled.p<{ $isClamped?: boolean }>`
	${NotinoBodyRegular};
	white-space: pre-wrap;

	${(p) =>
		p.$isClamped &&
		css`
			display: -webkit-box;
			-webkit-line-clamp: 4;
			-webkit-box-orient: vertical;
			overflow: hidden;
		`}
`

export const AboutUsShowMoreButton = styled.button`
	${resetButtonStyles};
	font-family: inherit;

	${NotinoBodyMedium};
	margin-top: 28px;
`

export const EnumsItem = styled.div`
	${theme.typography.bodyRegular}

	width: 80px;
	text-align: center;
	flex-shrink: 0;
	padding-bottom: 4px; /* gap to (potential) horizontal scrollbar */
	display: grid;
	place-items: center;

	& > img {
		aspect-ratio: 1;
		object-fit: contain;
	}
`

export const LanguageContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 8px;
	padding-bottom: 4px; /* gap to (potenatial) horizontal scrollbar */
`

export const LanguageFlag = styled.div`
	width: 24px;
	height: 16px;
	display: flex;
	align-items: center;

	img {
		vertical-align: unset !important; // overwriting notino default style
	}
`

export const LanguageTitle = styled.div`
	${theme.typography.bodyLarge}
	white-space: nowrap;
`

export const MapContainer = styled.div`
	position: relative; // needed for GoogleMapComponent
	aspect-ratio: 2;
	margin-bottom: 20px;
`

export const Address = styled.div`
	${NotinoBodyLarge};
	margin-bottom: 16px;
`

export const AddressDescription = styled.p`
	${NotinoBodySmall};
	white-space: pre-wrap;
	color: ${theme.color.text.tertiary};
	margin-bottom: 16px;
`

export const LinkButton = styled(Button)`
	// fix for notino button when using href
	display: flex;
	align-items: center;

	justify-content: center;
	gap: 8px;
`

export const ParkingDescription = styled.p`
	${NotinoBodySmall};
	white-space: pre-wrap;
	color: ${theme.color.text.tertiary};
`

export const MailLink = styled.a`
	color: inherit;
	text-decoration: none;
`
